import { translations } from '../translations/translations.js';

const supportedLang = ['es', 'en']

export const _ = (text) => {
	if (!window.lang || !supportedLang.includes(window.lang)) {
		window.lang = 'en'
	}
    if (translations[window.lang][text] === undefined) {
        return text
    }
	return translations[window.lang][text]
}